import React from "react";

const industries = [
  { icon: "🏭", label: "Industrial Facilities"    },
  { icon: "🏨", label: "Hotels"                   },
  { icon: "🏢", label: "Commercial Buildings"     },
  { icon: "🏘️", label: "Residential Areas"        },
  { icon: "🏥", label: "Healthcare Facilities"    },
  { icon: "🏛️", label: "Government Buildings"     },
  { icon: "🎓", label: "Educational Institutions" },
];

export default function Industries() {
  return (
    <section className="bg-white py-10 sm:py-16 font-poppins">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">

        {/* Title */}
        <div className="flex justify-center mb-8 sm:mb-10">
          <h2
            className="text-lg sm:text-4xl rounded-md font-extrabold text-white px-6 sm:px-12 py-3 tracking-widest text-center"
            style={{ backgroundColor: "#0F1030" }}
          >
            INDUSTRIES WE SERVE
          </h2>
        </div>

        {/* 2 cols mobile, 3 cols tablet, 4 cols desktop */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {industries.map((ind) => (
            <div key={ind.label} className="text-center group cursor-pointer">
              <div
                className="rounded-xl p-3 sm:p-4 mb-2 sm:mb-3 flex items-center justify-center h-16 sm:h-24 w-full transition-colors group-hover:opacity-90"
                // style={{ backgroundColor: "#0F1030" }}
              >
                <span className="text-3xl sm:text-5xl">{ind.icon}</span>
              </div>
              <p className="text-xs sm:text-sm font-semibold" style={{ color: "#0F1030" }}>
                {ind.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}